
/**
 * Generates a random 6-character alphanumeric trip code
 */
export const generateTripCode = (): string => {
  // Characters to use for generating the code (excluding easily confused characters)
  const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let result = '';
  
  // Generate a 6-character code
  for (let i = 0; i < 6; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }
  
  return result;
};
